export function buildClassicRegistrationAvailabilityPayload(
  values = {},
  { language = "en", registrationFlowId = "" } = {}
) {
  return {
    username: values.username,
    email: values.email,
    password: values.password1,
    language: language || "en",
    registration_flow_id: registrationFlowId,
    registration_method: "classic",
  };
}

export function getPublicAuthRequestConfig() {
  return {
    meta: {
      suppressUnauthorizedRedirect: true,
      authOptional: true,
      skipNativeAuth: true,
      suppressGlobalError: true,
    },
  };
}

export function normalizeRegistrationAvailabilityErrors(errors) {
  if (!errors || typeof errors !== "object" || Array.isArray(errors)) return errors;

  const normalized = { ...errors };
  if (normalized.password && !normalized.password1) {
    normalized.password1 = normalized.password;
  }
  delete normalized.password;
  return normalized;
}
